/**
 * "Year Make Model Submodel", the way a vehicle is shown everywhere (the server's
 * Vehicle::full_vehicle reads the same). Falls back to a prepared display name when the
 * vehicle carries no structured fields.
 */
export function vehicleLabel(vehicle) {
  const source = vehicle || {};
  const label = [source.year, source.make, source.model, source.submodel ?? source.subModel]
    .map((part) => String(part ?? '').trim())
    .filter((part) => part !== '' && part !== '0')
    .join(' ');

  return label || String(source.displayName || source.full_vehicle || '').trim();
}
